export default __webpack_public_path__ + "static/media/webtrader.3fb600f3.png";